module.exports = __webpack_public_path__ + "img/nestegg_partner_graph.193fc1a7.svg";